import React from 'react';
import Icon from '../../tc-ui/icon';
import R from 'ramda';

const border = '1px solid #e0e0e0';
export default ({ bedsAndSofas, style }) => (
  <div style={R.merge({ backgroundColor: 'white', border, marginBottom: '4px' }, style)}>
    {
      (bedsAndSofas.rooms || []).map((room = [], roomIndex) => (
        <div key={roomIndex}>
          <div style={{ display: bedsAndSofas.isApartment ? 'block' : 'none', height: '30px', backgroundColor: '#fafafa', lineHeight: '30px', paddingLeft: '8px', borderBottom: border, borderTop: roomIndex ? border : '' }}>
            Room {roomIndex + 1}
          </div>
          <div style={{ padding: '8px' }}>
            {
              room.map((config = [], configIndex) => (
                <div key={configIndex}>
                  <div style={{ display: configIndex > 0 ? 'block' : 'none', fontSize: '12px', padding: '4px 20px' }}>- OR -</div>
                  <div style={{ display: !bedsAndSofas.isApartment && room.length < 2 ? 'none' : 'block' }}>
                    <Icon className="tc-icon-hotel" style={{ top: '1px', fontSize: '16px', marginRight: '4px' }} />
                    Configuration {room.length > 1 ? configIndex + 1 : ''}
                  </div>
                  {
                    config.map((beddingInfo = {}, beddingIndex) => (
                      <div key={beddingIndex} style={{ paddingLeft: '20px' }}>
                            <span style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                              {(beddingInfo || {}).count}
                            </span> X <span style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                              {(beddingInfo || {}).bedType === 'Other' ? (beddingInfo || {}).other : (beddingInfo || {}).bedType}
                            </span>
                      </div>))
                  }
                </div>))
            }
          </div>
        </div>))
    }
  </div>
);



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/bedding-configuration-dumb.jsx